import { render, staticRenderFns } from "./fangpian.vue?vue&type=template&id=734af9a3&scoped=true&"
import script from "./fangpian.vue?vue&type=script&lang=js&"
export * from "./fangpian.vue?vue&type=script&lang=js&"
import style0 from "./fangpian.vue?vue&type=style&index=0&id=734af9a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734af9a3",
  null
  
)

export default component.exports